$(function(){
  
  let isAllSet = false;
  
  $('.wrappingmodal-name-element').val('');
  
  // イベント
  $('.js-stitch-open-btn').on('click', function(e){
    e.preventDefault();
    document.body.classList.add('stitch-modal-open');
    
    _setMode( $('input[name="properties[種類]"]').val(), true );
  });

  $('.js-stitch-close-btn').on('click', function(e){
    e.preventDefault();
    document.body.classList.remove('stitch-modal-open');
  });

  $('.stitchmodal').on('click', function(e){
    e.preventDefault();
    document.body.classList.remove('stitch-modal-open');
  });

  $('.js-stitch-decision-btn').on('click', function(e){
    e.preventDefault();
    document.body.classList.remove('stitch-modal-open');
  });

  $('.stitchmodal-inner').on('click', function(e){
    e.stopPropagation();
  });

  $('.js-stitch-clear-btn').on('click', function(e){
    e.preventDefault();
    
     $('#ProductContents').removeClass('is-set-stitch');
    _clearAll();
  });
  
  $('.wrappingmodal-select-element').on('change', function(){
    _checkProp();
  });
  
  $('input[name="properties[種類]"]').on('change', function(){
    let value = $(this).val();
    _setMode( value, true );
  });
  
  $('input[name="properties[表書き]"]').on('change', function(){
    let value = $(this).val();
    let mizuhiki = $(this).data('category');
    
    $('#ProductSelectedWrappingCategory').text( mizuhiki );
    $('#ProductSelectedWrappingOmote').text( value );
    $('input[name="properties[水引き]"]').val( mizuhiki );
  });
  
  $('input[name="名入れ"]').on('change blur', function(){
    let value = $(this).val();
    $('#ProductSelectedWrappingNaire').text( value );
    $('input[name="properties[名入れ]"]').val( value );
  });
  
  $('input[name="properties[掛け方]"]').on('change', function(){
    let value = $(this).val();
    $('#ProductSelectedWrappingKakekata').text( value );
  });
  
  $('[data-submit-button]').on('click', function(e){
	e.preventDefault();
    
    // 値がセットされていないときは
    // 値を送らないように要素を削除してから送信する
    if( !isAllSet ){
      _removeField();
    }
    
    if( $('input[name="properties[水引き]"]').val() == '' ){ $('input[name="properties[水引き]"]').remove(); }
    if( $('input[name="properties[名入れ]"]').val() == '' ){ $('input[name="properties[名入れ]"]').remove(); }

    $('.shopify-product-form').submit();
  });
  

  // functions
  
  function _setMode( target, changeFront ){
    if( target == 'のし・掛け紙' ){
      $('input[value="のし・掛け紙"]').prop('checked', true);
      $('.wrappingmodal-noshi').show();
      
      if( changeFront ){
        $('#ProductSelectedWrapping').text( 'のし・掛け紙' );
        $('.l-productStitch__text').show();
      }
      
      _checkProp();
    }
    else {
      $('input[value="リボン掛け"]').prop('checked', true);
      $('.wrappingmodal-noshi').hide();
      
      if( changeFront ){
        $('#ProductSelectedWrapping').text( 'リボン掛け' );
        $('.l-productStitch__text').hide();
      }
      else {
        $('.l-productStitch__text').show();
      }
      
      _clearNoshi();
      _turnOnBtn();
    }
  }
  
  function _checkProp(){
    if( $('input[name="properties[表書き]"]:checked').val() && $('input[name="properties[掛け方]"]:checked').val() ){
      _turnOnBtn();
    }
    else {
      _turnOffBtn();
    }
  }
  
  function _clearNoshi(){
    $('input[name="properties[表書き]"]:checked').prop('checked', false);
    $('input[name="properties[掛け方]"]:checked').prop('checked', false);
    $('input[name="properties[名入れ]"]').val(null);
    $('input[name="properties[水引き]"]').val(null);
  }
  
  function _clearAll(){
    $('input[name="properties[種類]"]:checked').prop('checked', false);
    $('input[name="properties[表書き]"]:checked').prop('checked', false);
    $('input[name="properties[掛け方]"]:checked').prop('checked', false);
    $('input[name="properties[名入れ]"]').val(null);
    $('input[name="properties[水引き]"]').val(null);
  }
  
  function _turnOnBtn(){
    $('.stitchmodal-submit').removeClass('off');
    $('#ProductContents').addClass('is-set-stitch');
    
    isAllSet = true;
  }
  
  function _turnOffBtn(){
    $('.stitchmodal-submit').addClass('off');
    $('#ProductContents').removeClass('is-set-stitch');
    
    isAllSet = false;
  }
  
  function _removeField(){
    $('.wrappingmodal-category-element, .wrappingmodal-mizuhiki-element, .wrappingmodal-name-element, .wrappingmodal-select-element').remove();
  }

});